module.exports = __webpack_public_path__ + "static/media/mail-icon.4e6ad230.svg";